// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30Agt","clinicsSelect":"styles_clinicsSelect__3N7bn"};